import { Typography } from '@breetometer/components';
import { capitalizeFirstLetter } from 'BreetHelpers';
import type { RefObject } from 'react';

import { DropDownControl } from './components/Controls';
import { InputValue } from './components/Inputvalue';
import { DropdownItems } from './components/Items';
import { DropdownWrapper } from './components/Wrapper';
import type { IDropDown } from './Dropdown.helpers';

const DropDown = ({
	handleItemSelect,
	selectedItem,
	items,
	iconAs,
	hideValue,
	placeholder,
	label,
	id,
	children,
	errorMessage,
	hideSearch,
	CustomItemOption,
}: IDropDown) => (
	<div
		className='dropdown'
		data-testid='dropdown'
	>
		<DropdownWrapper>
			{(dropDownArgs) => {
				const { buttonRef, handleVisibility, visible, dropdownRef, controlRef, dropdownStyles } = dropDownArgs;

				return (
					<div className='dropdowninput bg-primary-500'>
						<div
							className='dropdown_content'
							ref={controlRef as RefObject<HTMLDivElement>}
						>
							<DropDownControl
								selectedItem={selectedItem}
								buttonRef={buttonRef}
								handleVisibility={handleVisibility}
								visible={visible}
								iconAs={iconAs}
							/>

							<label
								className='bt_label'
								htmlFor={id}
							>
								{label}
							</label>

							{children}

							{visible && (
								<DropdownItems
									handleItemSelect={handleItemSelect}
									dropDownRef={dropdownRef}
									hideSearch={hideSearch}
									inputValue={
										<InputValue
											icon={selectedItem?.icon as string}
											iconAs={iconAs}
											value={selectedItem?.value}
										/>
									}
									items={items}
									iconAs={iconAs}
									hideValue={hideValue}
									placeholder={placeholder}
									dropdownStyles={dropdownStyles}
									handleVisibility={handleVisibility}
									CustomItemOption={CustomItemOption}
								/>
							)}
						</div>
					</div>
				);
			}}
		</DropdownWrapper>
		{!!errorMessage && (
			<Typography
				as='p'
				className='dropdown_errormessage'
			>
				{capitalizeFirstLetter(errorMessage)}
			</Typography>
		)}
	</div>
);

export default DropDown;
